import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import media from '../../utils/mediaQueries';
import {
  ALICE_BLUE, BLUE_GREY, LINKS_COLOR, PALE_CORNFLOWER_BLUE, PALE_GREY, SOLITUDE, TEXT_COLOR,
} from '../../theme';
import Car from '../../images/icon-car.inline.svg';
import Moto from '../../images/icon-moto.inline.svg';
import { LicenseTypes, LICENSE_TYPES_DATA } from '../../constants/LicenseTypes';

const Container = styled.div`
  margin-top: 32px;
  
  ${media.mobile`
    margin-top: 20px;
  `}
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 800;
  line-height: 1.38;
  letter-spacing: 0.2px;
  margin-bottom: 12px;
  
  ${media.mobile`
    margin-bottom: 8px;
  `}
`;

const SwitchList = styled.div`
  display: flex;
  
  ${media.mobile`
    flex-direction: column;
  `}
`;

const InputView = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 16px;
  border: solid 1px ${SOLITUDE};
  position: relative;
  flex-shrink: 0;
  
  &::after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 8px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: ${LINKS_COLOR};
    display: none;
  }
`;

const CarIcon = styled(Car)`
  fill: ${LINKS_COLOR};
  fill-rule: evenodd;
  width: 24px;
  height: 10px;
  flex-shrink: 0;
`;

const MotoIcon = styled(Moto)`
  fill: ${BLUE_GREY};
  fill-rule: evenodd;
  width: 24px;
  height: 10px;
  flex-shrink: 0;
`;

const SwitchItem = styled.label`
  border-radius: 9px;
  border: 1px solid ${PALE_GREY};
  display: flex;
  padding: 7px 12px 9px;
  color: ${BLUE_GREY};
  font-size: 16px;
  line-height: 1.38;
  letter-spacing: -0.1px;
  cursor: pointer;
  margin: 0 0 0 12px;
  
  ${(props) => props.checked
    && (
      css`
        color: ${LINKS_COLOR};
        border-color: ${PALE_CORNFLOWER_BLUE};
        background: ${ALICE_BLUE};
        
        ${InputView} {
          &::after {
            display: block;
          }
        }
        
        ${MotoIcon} {
          fill: ${LINKS_COLOR}
        }
      `
    )
}
  
  ${media.mobile`
    margin-left: 0;
    margin-bottom: 8px;
  `}
`;

const SwitchItemHighlighted = styled(SwitchItem)`
  border-color: ${PALE_CORNFLOWER_BLUE};
  color: ${TEXT_COLOR};
  margin-left: 0;
`;

const InputLabel = styled.div`
  width: 100%;
  margin: 0 8px;
`;

const Input = styled.input`
  position: absolute !important;
  height: 1px; 
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap; 
`;

const LicenseSwitcher = ({ activeItem, handleTypeClick }) => (
  <Container>
    <Title>Je souhaite passer l’examen suivant</Title>
    <SwitchList>
      <SwitchItemHighlighted checked={activeItem === LicenseTypes.ETG}>
        <Input
          type="radio"
          name="license_type"
          value={LicenseTypes.ETG}
          onClick={handleTypeClick}
        />
        <InputView />
        <InputLabel>
          <div>{LICENSE_TYPES_DATA[LicenseTypes.ETG].abbr}</div>
          <div>{LICENSE_TYPES_DATA[LicenseTypes.ETG].descr}</div>
        </InputLabel>
        <CarIcon />
      </SwitchItemHighlighted>

      <SwitchItem checked={activeItem === LicenseTypes.ETM}>
        <Input
          type="radio"
          name="license_type"
          value={LicenseTypes.ETM}
          onClick={handleTypeClick}
        />
        <InputView />
        <InputLabel>
          <div>{LICENSE_TYPES_DATA[LicenseTypes.ETM].abbr}</div>
          <div>{LICENSE_TYPES_DATA[LicenseTypes.ETM].descr}</div>
        </InputLabel>
        <MotoIcon />
      </SwitchItem>
    </SwitchList>
  </Container>
);

LicenseSwitcher.propTypes = {
  activeItem: PropTypes.string,
  handleTypeClick: PropTypes.func,
};

LicenseSwitcher.defaultProps = {
  activeItem: '',
  handleTypeClick: () => {},
};

export { LicenseSwitcher };
